export default __webpack_public_path__ + "static/media/mobile_90s@2x.caba158e.jpg";